import { render, staticRenderFns } from "./tensorflow.vue?vue&type=template&id=70f07648&"
import script from "./tensorflow.vue?vue&type=script&lang=js&"
export * from "./tensorflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports